




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Validation } from 'vuelidate';
import { AddressExtended, RawAddress } from '@/models/extensions';

@Component({
	components: {},
})
export default class AdrLookup extends Vue {
	@Prop({
		default: () => {
			return { fullAdr: '', rawAddress: {} };
		},
	})
	public value?: AddressExtended;
	public place?: RawAddress;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	@Prop(Object)
	public readonly validator?: Validation;

	public renderKey = 0;

	get validationState() {
		if (this.validator) {
			// @ts-ignore
			return this.validator.fullAdr.$dirty && this.validator.fullAdr.$invalid;
		}
		return null;
	}

	public setPlace(place: any) {
		if (this.validator) {
			this.validator.$touch();
		}
		this.place = place;
	}

	public usePlace(e: Event) {
		e.preventDefault();
		if (this.place) {
			this.setObject();
		}
	}

	public setObject() {
		if (!this.value || !this.place) return;
		this.value.fullAdr = ((this.place.adr_address || this.place.formatted_address) ?? '').replace(
			/(<([^>]+)>)/gi,
			'',
		);
		this.value.rawAddress = this.place;
		this.renderKey = +!this.renderKey;
		this.$emit('setAddress', this.value);
	}
}
